<template>
  <ODialog ref="dialog" hideWhenLoading :maxWidth="700">
    <v-card v-if="row != null">
      <ODialogBar title="Editar Veículo" @close="dismiss" />
      <v-card-text class="pa-3">
        <TagsReferenceDialog ref="tagsReferenceDialog" />

        <v-form ref="theForm" v-model="isValid">
          <div class="d-flex flex-row flex-wrap">
            <OTextField
              class="w-1/2 pa-3"
              v-model="row.code"
              label="Placa"
              :rules="[isSet]"
            />

            <OTextField
              class="w-1/2 pa-3"
              v-model="row.extraCode"
              label="Código Auxiliar (mapa)"
            />

            <OAutocomplete
              class="w-1/2 pa-3"
              v-model="row.brandModelId"
              label="Marca/Modelo"
              placeholder="Selecione..."
              :items="allBrandModels"
            />

            <OAutocomplete
              class="w-1/2 pa-3"
              v-model="row.group"
              label="Grupo"
              placeholder="Selecione..."
              :items="allGroups"
              :rules="[maybeRequired]"
            />

            <div class="w-full d-flex align-center justify-space-between pa-3">
              <OTagsInput v-model="row.tags" :items="allTags" label="Tags" />

              <v-btn icon @click="showTagsReference">
                <v-icon>mdi-notebook</v-icon>
              </v-btn>
            </div>

            <OTextarea
              class="w-full pa-3"
              v-model="row.description"
              label="Descrição"
              :rows="3"
            />
          </div>
        </v-form>
      </v-card-text>
      <ODialogButtons
        class="pa-4"
        txtApply="Salvar"
        @apply="apply"
        @cancel="dismiss"
      />
    </v-card>
  </ODialog>
</template>

<script>
import { isBlank } from 'oderon-commons/src/utils'
import TagsReferenceDialog from './TagsReferenceDialog.vue'
import OTagsInput from 'oderon-vue/cpts/OTagsInput.vue'
import { Vehicle, BrandModel } from '../../models'
import { isSet } from 'oderon-vue/utils.js'

export default {
  components: {
    TagsReferenceDialog,
    OTagsInput
  },
  data() {
    return {
      id: null,
      row: null,
      allTags: [],
      allBrandModels: [],
      allGroups: [],
      isValid: false,

      isSet,

      maybeRequired: (x) => {
        if (this.groupRequired && isBlank(x)) {
          return 'Obrigatório'
        } else {
          return true
        }
      }
    }
  },
  computed: {
    groupRequired() {
      return this.allGroups.length > 1
    }
  },
  methods: {
    /**
     * @param {Number} vehicleId - ID global do veículo
     */
    open(vehicleId) {
      this.id = vehicleId
      this.isValid = false
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },

    async fetchData() {
      let v = await Vehicle.findById(this.id)
      if (v.extraInfo == null) v.extraInfo = {}

      // Para efeito da edição, se alguma tag
      // começa com "Grupo:", remove da lista.
      if (v.tags == null) v.tags = []
      v.tags = v.tags.filter((x) => !x.toLowerCase().startsWith('grupo:'))

      // Demais fetchs
      await Promise.all([
        this.fetchBrandModels(),
        this.fetchVehicleGroups(v.orgId),
        this.fetchTagCloud(v.orgId)
      ])

      this.row = v
    },

    async fetchBrandModels() {
      let { rows: items } = await BrandModel.findAll({ limit: 10000 })
      this.allBrandModels = items.map((x) => {
        let chips = []
        if (x.deletedAt != null)
          chips.push({ text: 'Desativado', color: 'error' })
        return {
          value: x.id,
          text: x.name,
          chips
        }
      })
    },

    async fetchVehicleGroups(orgId) {
      try {
        let allGroups = await Vehicle.findGroups(orgId)
        allGroups = allGroups.map((x) => ({ value: x.code, text: x.code }))
        allGroups.unshift({ code: null, text: '(nenhum)' })
        this.allGroups = allGroups
      } catch (err) {
        this.allGroups = []
      }
    },

    async fetchTagCloud(orgId) {
      let allTags = await Vehicle.findTagCloud(orgId)
      this.allTags = allTags
        .map((x) => x.code)
        .filter((x) => !x.toLowerCase().startsWith('grupo:'))
        .sort()
    },

    apply() {
      this.$refs.theForm.validate()
      if (this.isValid) {
        this.$refs.dialog.$loading(async () => {
          await Vehicle.patch(this.id, this.row)
          this.$snack('Salvo com sucesso')
          this.$refs.dialog.$apply(true) // reload na tela de baixo
        })
      }
    },

    dismiss() {
      this.$refs.dialog.$dismiss()
    },

    showTagsReference() {
      this.$refs.tagsReferenceDialog.open()
    }
  }
}
</script>

<style></style>
